import {isFeatureEnabled} from '@github-ui/feature-flags'
import {useAppPayload} from '@github-ui/react-core/use-app-payload'

import type {AppPayload} from '../types/app-payload'
import type {SemanticSearchFeaturePreview} from './use-issues-index-semantic-search-toggle-feature-preview'

const useIssuesDashboardSemanticSearchFeaturePreview: () => SemanticSearchFeaturePreview = () => {
  const {semantic_search_enrolled, current_user} = useAppPayload<AppPayload>()
  const isAvailable = isFeatureEnabled('issues_dashboard_semantic_search')

  const isEnabled = semantic_search_enrolled ?? false
  const isStaff = current_user?.is_staff ?? false

  return {isAvailable, isEnabled, isStaff}
}

export {useIssuesDashboardSemanticSearchFeaturePreview}
